export enum SwitchDesignModes {
  MODE_SWITCH = 'mode-switch',
  DEFAULT = 'default',
  HIRE_SWITCH = 'hire-switch',
  RESUME_SWITCH = 'resume-switch',
  NOTIFICATIONS_SWITCH = 'notifications-switch',
  LOCATION_SWITCH = 'location',
}